import { defineComponent as _defineComponent } from 'vue'
import { useRoutingStore } from '@/stores/pinia/useRoutingStore';
import { storeToRefs } from 'pinia';
import { computed, onBeforeMount, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router/composables';

export default /*#__PURE__*/_defineComponent({
  __name: 'SportsFooter',
  setup(__props) {

const SportsDefaultFooter = () =>
	import(/* webpackChunkName: "default-footer" */ '@/features/sports/components/global/SportsDefaultFooter.vue');

const coldStart = ref(true);
const metaReady = ref(false);
const { urlMetadataPromise } = storeToRefs(useRoutingStore());
const route = useRoute();

const showDefaultFooter = computed(() => {
	return route.name !== 'app.home';
});

onBeforeMount(async () => {
	await urlMetadataPromise.value;
	metaReady.value = true;
});

onMounted(() => {
	coldStart.value = false;
});

return { __sfc: true,SportsDefaultFooter, coldStart, metaReady, urlMetadataPromise, route, showDefaultFooter }
}

})